// extracted by mini-css-extract-plugin
export var defaultWrapper = "_lb-3";
export var downloadButton = "_lb-4";
export var fileContainer = "_lb-9 _lb-7";
export var fileContainerBase = "_lb-7";
export var fileContainerFixedHeight = "_lb-8 _lb-7";
export var fileInfo = "_lb-5";
export var fileInfoWidthRestricted = "_lb-6";
export var fileType = "_lb-1";
export var fileTypeName = "_lb-2";
export var image = "_lb-0";
export var link = "_lb-b";
export var overflowEllipsis = "_lb-a";